module.exports = __webpack_public_path__ + "img/aboutUsImg11.13f43e81.png";